<div mat-dialog-content>
    <div class="sectionEdit-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-genSectionNew (closeDialog)="onClose()" [sectionId]="sectionId"></app-genSectionNew>
</div>